import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const ErrorWidgetContainer = styled.div<{ hasCustomPadding?: { top?: number; bottom?: number } }>(
    ({ theme, hasCustomPadding }) => ({
        background: theme.colors[theme.colorMode].background_Primary,
        paddingTop: hasCustomPadding?.top,
        paddingBottom: hasCustomPadding?.bottom,
    }),
);

export const TextContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xSmall,
    marginBottom: theme.spacing.medium,
}));

export const TitleText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
}));

export const SubTitleText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
}));

export const ButtonsWrapper = styled.div(({ theme }) => ({
    width: "100%",
    display: "flex",
    gap: theme.spacing.small,
}));

export const ButtonContainer = styled.div(() => ({
    width: "100%",
}));
